import identityService from '../services/identity.service';

const identities = {
    namespaced: true,
    state: {
        identityTypes: null,
    },
    actions: {
        //CREATE
        create(_, model) {
            return identityService.create(model);
        },

        //READ
        get(_, params) {
            return identityService.get(params.id, params.urlParameters, params.requestId);
        },
        getByIdentificationTypeAndNumber(_, params) {
            return identityService.getByIdentificationTypeAndNumber(params.urlParameters, params.requestId);
        },
        getlist() {
            return identityService.getlist();
        },
        async getTypes({commit, state, getters}) {
            if (state.identityTypes === null) {
                var response = await identityService.getTypes();
                commit('setIdentityTypes', response.data);
            }
            return getters.identityTypes;
        },
        verifyRsaId(_, idNumber) {
            return identityService.verifyRsaId(idNumber);
        },

        //UPDATE
        update(_, params) {
            return identityService.update(params.id, params.formData);
        },

        //DELETE
        /*delete(_, id) {
            return identityService.delete(id);
        },*/
    },
    getters: {
        identityTypes: (state) => state.identityTypes,
    },
    mutations: {
        setIdentityTypes(state, types) {
            state.identityTypes = types;
        },
    },
};

export default identities;
